import axios from "axios";
import React, { useEffect } from "react";
import { CommentSection } from "react-comments-section";
import "react-comments-section/dist/index.css";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { webServiceUrl } from "../../../components/apiCall/webserviceurl";
import { toast, ToastContainer } from "react-toastify";
import { Col, Container, Row } from "react-bootstrap";
import { FaArrowLeft, FaRegCommentDots } from "react-icons/fa";
import Card from "../../../components/Card";

const Threads = () => {
  const { enqueryId } = useParams();
  console.log(enqueryId);

  //   const location = useLocation()
  //   const query = location.state?.file
  // console.log(location.state)
  // const school_code = location.state.school_code

  const navigate = useNavigate();

  const [query, setQuery] = React.useState([]);
  const course = JSON.parse(localStorage.getItem("course"));
  const courseData = course?.student;
  console.log(course);
  console.log(courseData);

  // Fallback if query is undefined
  const threads = async () => {
    try {
      const response = await axios.post(webServiceUrl.threadsById, {
        school_code: course?.school_code,
        response_by: courseData?.student_id,
        enquiry_id: enqueryId,
        student_name: courseData?.student_name,
        adm_no: courseData?.adm_no,
      });
      setQuery(response.data?.data ?? []);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    threads();
  }, []);
  console.log(query);
  if (!query) return <p>No enquiry data available.</p>;

  const data = [
    {
      userId: "01", // You can use adm_no or anything unique
      comId: query.enquiry_id || "001",
      fullName: courseData?.student_name,
      text: query.description,
      avatarUrl: `https://ui-avatars.com/api/name=${encodeURIComponent(
        query.student_name,
      )}&background=random`,
      timestamp: query.last_response_on,
      replies: query?.threads
        ? JSON.parse(query.threads).map((thread, index) => ({
            userId: `admin-${index}`,
            comId: `${query.enquiry_id}-reply-${index}`,
            fullName: thread.last_response_by,
            text: thread.reply_text,
            avatarUrl: `https://ui-avatars.com/api/name=${encodeURIComponent(
              thread.last_response_by,
            )}&background=random`,
            timestamp: new Date(thread.last_response_on).toISOString(),
          }))
        : [],
    },
  ];

  const reply_text = async (text) => {
    try {
      if (!text || text.trim() === "") {
        toast.warn("Reply cannot be empty.");
        return;
      }

      const resp = await axios.post(webServiceUrl.replyOnQuery, {
        school_code: course?.school_code,
        enquiry_id: enqueryId,
        reply: text,
        response_by: courseData?.student_name,
      });

      if (resp?.data?.success) {
        toast.success("Reply sent successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        threads();
        // Optional: Refresh thread or clear input
        // getQuiries(); or update state
      } else {
        toast.error(resp?.data?.message || "Failed to send reply.");
      }
    } catch (error) {
      console.error("Reply Error:", error);

      if (error.response) {
        toast.error(error.response.data?.message || "Server error occurred.");
      } else if (error.request) {
        toast.error("No response from server. Check your network connection.");
      } else {
        toast.error("An unexpected error occurred while sending the reply.");
      }
    }
  };

  return (
    <>
      <div id="content-page" className="content-inner">
        <ToastContainer />
        {/* Scoped UI-only overrides for the third-party comment section, kept in
            the white + #16a34a theme. No component logic is affected. */}
        <style>{`
          .comment_section .postBtn {
            background-color: #16a34a !important;
            border-color: #16a34a !important;
            border-radius: 999px !important;
            font-weight: 600 !important;
            padding: 6px 20px !important;
            box-shadow: 0 4px 14px rgba(22, 163, 74, 0.3);
          }
          .comment_section .postBtn:hover {
            background-color: #128a3e !important;
            border-color: #128a3e !important;
          }
          .comment_section textarea {
            border-radius: 12px !important;
            border: 1px solid #bbf7d0 !important;
          }
          .comment_section textarea:focus {
            border-color: #16a34a !important;
            box-shadow: 0 0 0 3px rgba(22, 163, 74, 0.15) !important;
          }
          .comment_section .replyBtn,
          .comment_section .viewRepliesBtn {
            color: #16a34a !important;
            font-weight: 600 !important;
          }
          .comment_section img {
            border: 2px solid #dcfce7;
          }
        `}</style>
        <Container fluid>
          <Row className="justify-content-center">
            <Col lg="10">
              <Card
                className="shadow border-0 rounded-4 overflow-hidden px-0 px-md-4"
                style={{ background: "#ffffff" }}
              >
                <Card.Header
                  className="my-1 my-md-4 py-3 px-3 border-0"
                  style={{ background: "transparent" }}
                >
                  <div className="d-flex align-items-center gap-3">
                    <button
                      type="button"
                      onClick={() => navigate(-1)}
                      className="d-inline-flex align-items-center justify-content-center rounded-circle border-0"
                      style={{
                        width: 38,
                        height: 38,
                        background: "#f0fdf4",
                        border: "1px solid #bbf7d0",
                        color: "#16a34a",
                        flexShrink: 0,
                      }}
                      aria-label="Go back"
                    >
                      <FaArrowLeft size={14} />
                    </button>

                    <div className="d-flex align-items-center gap-2">
                      <span
                        className="d-inline-flex align-items-center justify-content-center rounded-circle"
                        style={{
                          width: 42,
                          height: 42,
                          background: "#16a34a",
                          color: "#fff",
                          flexShrink: 0,
                        }}
                      >
                        <FaRegCommentDots size={18} />
                      </span>
                      <div>
                        <h4 className="mb-0 fw-bold">View Threads</h4>
                        <small className="text-muted">
                          Conversation for this query
                        </small>
                      </div>
                    </div>
                  </div>
                </Card.Header>

                <Card.Body className="px-2 px-md-3 py-3">
                  <div
                    className="comment_section rounded-4 p-3 p-md-4"
                    style={{
                      background: "#fafffb",
                      border: "1px solid #eefdf2",
                    }}
                  >
                    <CommentSection
                      currentUser={{
                        currentUserId: enqueryId,
                        currentUserImg: `https://ui-avatars.com/api/name=${encodeURIComponent(
                          courseData?.student_name,
                        )}&background=random`,
                        currentUserProfile: "#",
                        currentUserFullName: courseData?.student_name,
                      }}
                      logIn={{
                        onLogin: () => alert("Call login function"),
                        signUpLink: "http://localhost:3001/",
                      }}
                      commentData={data}
                      placeholder="Write your reply..."
                      currentData={(data) => console.log("current data", data)}
                      onSubmitAction={(comment) => {
                        reply_text(comment.text);
                      }}
                    />
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Threads;
